module.exports = __webpack_public_path__ + "img/y_2014_hover.b8e972e2.png";